// extracted by mini-css-extract-plugin
module.exports = {"heartRateTipsStyle":"_2v0eXxeg4CQPas4wEs9ebn"};